module.exports = __webpack_public_path__ + "static/media/maynoothuni.acdcb6ae.png";